module.exports = __webpack_public_path__ + "img/logo-indiqueivc-text.1d537acf.svg";